/**
 * main jquery code used as plugin
 * the jquery framework is linked externally from their cdn in the app.php
 * @filesource  ./app/js/app.js
 * @license     CC BY-SA 4.0 (https://creativecommons.org/licenses/by-sa/4.0/)
 * @author      Rej <rej>
 * @return      something amazing
 * @link        https://jquery.com/
 */
$(function(){

    // subnav hidden on mobile scroll
    // @return tpl -> nav.php
    var UIHeader = $("header");
    var UIDivTransparent = $("div.drkbg");
    var UIFirstArticle = $(".fst");
    var UIScroll = "280";

    $(window).scroll(function(e) {

        if ($(this).scrollTop() > UIScroll) {
            UIHeader.addClass("fheader animate fadeInDown");
            UIDivTransparent.addClass("fheader");
            UIFirstArticle.addClass("ffst");
        } else {
            UIHeader.removeClass("fheader animate fadeInDown");
            UIDivTransparent.removeClass("fheader");
            UIFirstArticle.removeClass("ffst");
        }

    });

    var UIMobileNav = false;

    $("a.btmobilenav").click(function(e) {
        e.preventDefault();
        if (UIMobileNav == false) {
            if ($("header div.headernav").hasClass("navmoreshow") == true){
                $("header div.headernav").removeClass("navmoreshow");
                UIMobileNavMore = false;
            }
            $("nav").addClass("navshow");
            $("body").addClass("overflow-hidden");
            UIMobileNav = true;
        } else {
            $("nav").removeClass("navshow");
            $("body").removeClass("overflow-hidden");
            UIMobileNav = false;
        }
    });

    var UIMobileNavMore = false;

    $("a.btmobilenavmore").click(function(e) {
        e.preventDefault();
        if (UIMobileNavMore == false) {
            if ($("nav").hasClass("navshow") == true){
                $("body").addClass("overflow-hidden");
                $("nav").removeClass("navshow");
                UIMobileNav = false;
            }
            $("header div.headernav").addClass("navmoreshow");
            $("body").addClass("overflow-hidden");
            UIMobileNavMore = true;
        } else {
            $("header div.headernav").removeClass("navmoreshow");
            $("body").removeClass("overflow-hidden");
            UIMobileNavMore = false;
        }
    });


    $("nav ul li a.hnav").on("mouseover", function(n){
        n.preventDefault();
        var NavLink = $(this).attr("id");
        $("div.overlay").addClass("overlay-hide");
        $("div.overlay-"+NavLink).removeClass("overlay-hide");
    });
    $("div.overlay").on("mouseleave", function(){
        $("div.overlay").addClass("overlay-hide");
    });

    $("div.nav-links ul li a").on("mouseover", function(e) {
        //e.preventDefault();
        $(this).parent().next('span').removeClass("nav-links-hide");
    });
    $("div.nav-links ul").on("mouseleave", function() {
        $(this).children('span').addClass("nav-links-hide");
    });

    // hilde on scrolling
    $(window).bind('scroll', function(){
        setTimeout(function(){
            $("div.overlay").addClass("overlay-hide");
        }, 500);
    });

    // owl carousel slider for success success-stories
    // owl assets load in root -> app.php
    // @return sites -> success-stories.php

    $.each($(".slidr"), function () {
        var itemCount = $(this).find('.item').length;
        var config = {
            loop: itemCount > 1,
            mouseDrag: itemCount > 1,
            touchDrag: itemCount > 1,
            items: 1,
            singleItem: true,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 6000,
            autoplaySpeed: 1000,
            autoplayHoverPause: true,
            responsiveRefreshRate: 0,
            callbacks: true
        };
        if (typeof window.owlSliderConfig !== 'undefined') {
            $.extend(config, window.owlSliderConfig);
        }
        var owl = $(this).owlCarousel(config);

        $("div.c-r a").on("click", function(e) {
            owl.trigger('next.owl.carousel');
        });
        $("div.c-l a").on("click", function(e) {
            owl.trigger('prev.owl.carousel');
        });

        $('div.bt-chevron a').on('click', function(e){
            e.preventDefault();
        });
    });

    // animate scroll to park list
    $("a#ptop").click(function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $("#pagetop").offset().top
        }, 0);
    });


    // CTA
    // @file   ./app/tpl/cta.tpl
    // @file   ./app/css/ui.sass
    var UICta = false;
    var UICtaBtn = true;

    $("div.cta .trn").on("click", function(e) {
        if (UICta == false){
            $("div.cta-show-hide").addClass("animated slideInRight").removeClass("cta-show-hide");
            UICta = true;
        } else {
            UICta = false;
            $("div.cta-show").removeClass("animated slideInRight").addClass("cta-show-hide");
        }
    });
    // hide on click new CTA
    $("div.cta-show").on("click", function(a) {
        $(this).removeClass("animated slideInRight").addClass("cta-show-hide");
    });

    // hilde on scrolling
    $(window).bind('scroll', function(){
        setTimeout(function(){
            $("div.cta").addClass("cta-hide");
            UICtaBtn = false;
            $("div.cta-show").addClass("cta-show-hide");
            UICta = false;
        }, 200)
    });

    // toogle on scroll/stop
    $(window).bind('scroll', function(){
        clearTimeout($.data(this, 'scrollTimer'));
        $.data(this, 'scrollTimer', setTimeout(function() {
            UICtaBtn = true;
            $("div.cta").removeClass("cta-hide");
        }, 400));
    });

    // -> routing auf suche oder no suche
    $("a.bt-suche").on("click", function(s) {
        s.preventDefault();
        if ($("input#suche").val() != "") {
            location.href = "./suche";
        } else {
            location.href = "./suche-notreffer";
        }
    });
});

$(window).on('load', function () {
    // Sitelink UI behaviour toogle view while scrolling
    // open at end of site vs. close while scoll reverse
    // @return sites -> footer.php
    var siteHeight = $(document).height();
    var viewportHeight = $(window).height();
    $(window).on('resize init', function () {
        viewportHeight = $(window).height();

        if ($("footer div ul li ul.hide").length == 0) {
            $("footer div ul li ul").addClass("hide");
            siteHeight = $(document).height();
            $("footer div ul li ul").removeClass("hide");
        } else {
            siteHeight = $(document).height();
        }
    }).trigger('init');

    // workaround for inconsistent height of document
    window.setTimeout(function () { $(window).trigger('init') }, 300);

    $(window).on('scroll init', function () {
        if (siteHeight <= ($(this).scrollTop() + viewportHeight)) {
            $("footer div ul li ul").removeClass("hide");
        } else if (siteHeight > ($(this).scrollTop() + viewportHeight)) {
            $("footer div ul li ul").addClass("hide");
        }
    }).trigger('init');
});